import React from "react";
import { Mic, MicOff, Loader2, PhoneOff } from "lucide-react";
import { useVapi } from "@/hooks/useVapi";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { useRouterState } from "@tanstack/react-router";

export function VapiButton() {
  const { isActive, isConnecting, isSpeaking, start, stop } = useVapi();
  const router = useRouterState();

  const isAdminPage = router.location.pathname.startsWith("/admin");

  // Show VapiButton on all pages except admin
  if (isAdminPage) {
    return null;
  }


  return (
    <div className="flex flex-col items-end gap-3 pointer-events-none pr-4 sm:pr-6">
      {isActive && (
        <div className="bg-white/90 dark:bg-zinc-900/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg border border-primary/20 flex items-center gap-2 animate-in fade-in slide-in-from-bottom-2 pointer-events-auto">
          <div className="flex gap-1 items-center">
            <span className={cn(
              "w-2 h-2 rounded-full bg-primary",
              isSpeaking ? "animate-pulse" : "opacity-50"
            )} />
            <span className="text-xs font-medium text-foreground">
              {isSpeaking ? "Assistant speaking..." : "Listening..."}
            </span>
          </div>
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={stop}
            className="h-8 w-8 rounded-full hover:bg-destructive/10 hover:text-destructive"
          >
            <PhoneOff className="h-4 w-4" />
          </Button>
        </div>
      )}
      
      <Button
        onClick={(e) => {
          console.log("[VAPI_UI_ACTION_TRACE] Button onClick triggered", {
            isActive,
            isConnecting,
            target: e.target,
            currentTarget: e.currentTarget
          });
          e.preventDefault();
          e.stopPropagation();
          if (isActive) stop();
          else start();
        }}
        disabled={isConnecting}
        className={cn(
          "rounded-full h-14 w-14 shadow-xl border-2 transition-all duration-300 pointer-events-auto relative",
          isActive 
            ? "bg-destructive border-destructive text-white hover:bg-destructive/90 scale-90" 
            : "bg-primary border-primary text-primary-foreground hover:scale-105 active:scale-95"
        )}
        aria-label={isActive ? "End voice conversation" : "Talk to Healthy Kitchen"}
      >
        {isConnecting ? (
          <Loader2 className="h-6 w-6 animate-spin" />
        ) : isActive ? (
          <MicOff className="h-6 w-6" />
        ) : (
          <Mic className="h-6 w-6" />
        )}
      </Button>
      
      {!isActive && !isConnecting && (
        <span className="bg-white/80 dark:bg-zinc-900/80 backdrop-blur-sm px-3 py-1 rounded-md text-[10px] font-bold tracking-wider uppercase text-muted-foreground shadow-sm border border-border pointer-events-auto">
          Talk to Healthy Kitchen
        </span>
      )}
    </div>
  );
}
